<template lang="pug">
  transition(
    appear
    v-on:enter="enter"
    v-bind:css="false"
  )
    .PageTransitionLayer
      .PageTransitionLayer_container(ref="container")
        .PageTransitionLayer_patternMask(:style="patternMaskStyleObj" ref="patternMask")
          .PageTransitionLayer_patternContainer
            .PageTransitionLayer_pattern(:style="patternStyleObj" ref="pattern")
</template>

<script>

import {TweenLite, Power2} from 'gsap'
import SPEED from '@/const.speeds.js'
import COLOR from '@/const.colors.js'

export default {
  props: {
    speed: {
      type: Number,
      default: SPEED.NORMAL
    },
    delay: {
      type: Number,
      default: 0
    },
    backgroundImg: {
      type: String,
      required: false
    },
    backgroundColor: {
      type: String,
      required: false,
      default: COLOR.BODY
    }
  },
  computed: {
    patternMaskStyleObj () {
      const style = {}

      if (this.backgroundColor) {
        style['background-color'] = `${this.backgroundColor}`
      }

      return style
    },
    patternStyleObj () {
      const style = {}

      if (this.backgroundImg) {
        style['background-image'] = this.backgroundImg == 'none' ? 'none' : `url(${this.backgroundImg})`
      }

      return style
    }
  },
  methods: {
    /**
     * Enter animation
     */
    enter () {
      // Calculate sizes before animation
      const elRect = this.$el.getBoundingClientRect(),
        elDiagonalSize = Math.sqrt(elRect.width ** 2 + elRect.height ** 2),
        diagonalAngle = 90 - ((Math.atan(elRect.width / elRect.height) * 180 / Math.PI)),
        layerAngle = 45 - diagonalAngle,
        layerHeight = elDiagonalSize * Math.cos(layerAngle * Math.PI / 180),
        ease = Power3.easeInOut,
        delay = this.delay,
        speed = this.speed

      // ---
      // Init sizes & positions
      // ---

      TweenLite.set(this.$refs.container, {
        x: elRect.width / 2,
        y: elRect.height / 2
      })

      TweenLite.set(this.$refs.patternMask, {
        width: layerHeight * 2,
        height: 0
      })

      TweenLite.set(this.$refs.pattern, {
        width: elRect.width + 50,
        height: elRect.height + 50,
        x: -elRect.width - 50,
        y: -elRect.height - 50
      })

      // ---
      // Animate sizes & positions
      // ---

      TweenLite.to(this.$refs.container, speed, {
        x: 0,
        y: 0,
        delay,
        ease
      })

      TweenLite.to(this.$refs.patternMask, speed, {
        height: layerHeight,
        delay,
        ease
      })

      TweenLite.to(this.$refs.pattern, speed, {
        x: -elRect.width / 2,
        y: -elRect.height / 2,
        delay,
        ease
      })
    }
  }
}
</script>

<style lang="stylus" scope>
  .PageTransitionLayer
    position: fixed
    top 0
    right 0
    left 0
    bottom 0

    &_container
      position: absolute
      top 0
      left 0
      right 0
      bottom 0

    &_patternMask
      position: absolute
      top 50%
      left 50%
      transform-origin: 50% 50%
      transform translate(-50%, -50%) rotateZ(-45deg)
      background-color #202020
      overflow hidden

    &_patternContainer
      position: absolute
      top 50%
      left 50%
      height 0
      overflow visible
      transform rotateZ(45deg)

    &_pattern
      position: absolute
      // background-image url('/img/backgrounds/relief_background.jpg')
      background-position 50% 50%
      background-repeat no-repeat
      background-size cover
</style>
